const CemeteryCross = Object.freeze({
  NONE: 'NONE',
  CIVIL_CROSS: 'CIC',
  CATHOLIC_CROSS: 'CAC',
})

export default CemeteryCross
